// angular imports
import { Component, Injector, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';

// devextreme imports
import { Column } from 'devextreme/ui/data_grid';

// cc-common imports
import { MessageBoxComponent, Utils } from 'cc-common';

// component imports
import { WorkOrderBaseComponent } from '../../../_base/work-order-base-component';

// model imports
import { WorkOrderResponsibleUsersResultDto } from '../../../_models/work-order-responsible-users-result-dto';
import { WorkOrderReferencesResultDto } from '../../../_models/work-order-references-result-dto';
import { WorkOrderEditorResultDto } from '../../../_models/work-order-editor-result-dto';
import { WorkOrderRawDto } from '../../../_models/work-order-raw-dto';
import { KeyValueResultDto } from '../../../../_models/key-value-result-dto';
import { BasePropertyParametersDto } from '../../../_models/base-property-parameter-dto';

@Component({
    selector: 'app-work-order-editor-job-info',
    templateUrl: './work-order-editor-job-info.component.html',
    styleUrls: ['./work-order-editor-job-info.component.scss']
})
export class WorkOrderEditorJobInfoComponent extends WorkOrderBaseComponent implements OnInit, OnChanges {
    @ViewChild('workOrderJobInfoMessgeBox', { static: false }) workOrderJobInfoMessgeBox: MessageBoxComponent;

    @Input() workOrderEditor: WorkOrderEditorResultDto;
    @Input() workOrderInfo: WorkOrderRawDto;
    @Input() customerId: string;

    referenceTypes: Array<KeyValueResultDto>;

    responsibleBoxValue: Array<string> = [];
    responsibleColumns: Array<Column> = [];

    showReferenceSelector = false;
    clearButton: any;

    constructor(protected readonly injector: Injector) {
        super(injector);

        this.onReferenceClick = this.onReferenceClick.bind(this);
        this.onReferenceTypeCodeChanged = this.onReferenceTypeCodeChanged.bind(this);
    }

    ngOnInit() {
        this.responsibleColumns = [
            {
                dataField: 'name',
                dataType: 'string',
                caption: 'Name'
            },
            {
                dataField: 'type',
                dataType: 'string',
                caption: 'Type'
            },
            {
                dataField: 'role',
                dataType: 'string',
                caption: 'Role'
            }
        ];

        this.clearButton = {
            icon: 'clear',
            type: 'normal',
            stylingMode: 'text',
            disabled: !this.workOrderInfo.communityId && this.workOrderInfo.communityId === 0,
            onClick: this.onReferenceTypeCodeChanged
        };
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.workOrderInfo && changes.workOrderInfo.currentValue) {
            this.workOrderInfo = changes.workOrderInfo.currentValue;
            if (Utils.notNullAndDefined(this.workOrderInfo)) {
                this.responsibleBoxValue = Utils.notNullAndDefined(this.workOrderInfo.responsibleId)
                    ? [this.workOrderInfo.responsibleId]
                    : [];
                this.getReferenceTypes();
            }
        }
    }

    onReferenceClick(): void {
        if (Utils.notNullAndDefined(this.workOrderInfo.referenceTypeCode)) {
            if (Utils.notEqualsIgnoreCase(this.workOrderInfo.referenceTypeCode, 'O')) {
                this.showReferenceSelector = true;
            }
        } else {
            this.workOrderJobInfoMessgeBox.showWarningMessage(
                'Warning',
                'Please select a reference type from the drop down.'
            );
        }
    }

    onReferenceSelect(record: WorkOrderReferencesResultDto): void {
        this.workOrderInfo.referenceId = record.referenceId;
        this.referenceName = record.reference;
    }

    onResponsibleSelection(selectedObject: any): void {
        if (Utils.notNullAndDefined(selectedObject) && Utils.notNullOrEmpty(selectedObject.selectedRow)) {
            const selectedRow: WorkOrderResponsibleUsersResultDto = selectedObject.selectedRow[0];
            this.workOrderInfo.responsibleId = selectedRow.userId;
        } else {
            this.workOrderInfo.responsibleId = null;
        }
    }

    onReferenceSelectorClose(): void {
        this.showReferenceSelector = false;
    }

    onReferenceTypeCodeChanged(): void {
        this.workOrderInfo.referenceId = null;
        this.references = [];
        this.referenceName = null;
    }

    private getReferenceTypes(): void {
        if (Utils.notNullOrEmpty(this.workOrderInfo.communityId)) {
            const baseParams: BasePropertyParametersDto = new BasePropertyParametersDto();
            baseParams.communityId = this.workOrderInfo.communityId;
            baseParams.clearCache = false;

            this.workOrderService.getReferenceTypes(baseParams).subscribe(
                (result: KeyValueResultDto[]) => {
                    this.referenceTypes = result;
                    if (Utils.notNullAndDefined(this.workOrderInfo.referenceTypeCode)) {
                        if (Utils.notNullAndDefined(this.workOrderInfo.referenceId)) {
                            this.populateReferences(this.workOrderInfo);
                        } else if (Utils.notNullAndDefined(this.customerId)) {
                            this.populateReferences(this.workOrderInfo, null, null, this.customerId);
                        }
                    }
                },
                (error) => {
                    this.errorService.displayError(error);
                }
            );
        }
    }
}
